import Lottie from "lottie-react";
import images from "../../assets/Icons/Icons";

const NoDataScreen = ({isBar, message}:{isBar?:boolean; message?: string}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <Lottie
        animationData={isBar ? images.emptyBar : images.yetiBored}
        loop
        autoplay
        style={{ width: 200, height: 200 }}
      />
      <p style={{ fontFamily: "'Balsamiq Sans', sans-serif", fontSize: 16, color: "#9A8E8E", margin: 0 }}>
        {message ?? "Awaiting learner's data..."}
      </p>
    </div>
  );
};

export default NoDataScreen;
